import {vnTemplate} from "../../../../valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {validationsList_template} from "../../../../valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import { filterTag_template } from "../../../../../../js/components/templates/filterTag_template";
import { DragAndDropHandler } from "../../../../../../js/utils/DragAndDropHandler";

declare var ko: any;

export class imagePickerBulkEdit_template extends vnTemplate {

    protected parent: any;
    public validationsList: validationsList_template;
    public filterTag: filterTag_template;

    protected getTemplateHtml(): string {

        return /* html */`
            <div class="w-img-picker-form" data-bind="css: { 'is-visible': isShown }">

                <div class="img-picker-form">

                    <div class="form-header">
                        <div class="section-title">
                            <h3 class="section-title" data-bind="text: 'Add ('+ images().length + ') new images' "></h3>
                        </div>
                        <button type="button" class="close-btn icon i-close" data-bind="event: { click: onClickCancel }"></button>
                    </div>

                    <div class="form-body">
                        ${ this.validationsList.getHtmlBuild() }

                        <!-- ko if: claidApiErrorMessage() -->
                        <div class="form-group">
                            <p class="form-text" style="color: red;" data-bind="text: claidApiErrorMessage"></p>
                        </div>
                        <!-- /ko -->
                        <div class="form-group">
                            <button class="btn secondary icon i-deselect" title="Deselect all" type="button" data-bind="event: { click: onSelectAll.bind($data, actionType()) }, text: actionType() +' all', visible: mode() != 'single-select' "></button>
                            <button class="btn secondary icon i-edit" title="Edit all" type="button" data-bind="click : onEditAll, text : 'Edit All', visible: mode() != 'single-select', css:{'is-disable': disable} "></button>
                        </div>

                        <div class="form-group hidden" data-bind="css: { 'is-visible': mode() == 'single-select'}">
                            <p class="form-text emph">Only one image can be selected and inserted as the field does not accept multiple.</p>
                        </div>

                        <div class="form-group">

                            <ul class="img-picker-list bulk-upload" data-bind="foreach: images" id="img-picker-list">

                                <li class="img-picker-item icon" draggable="true" data-bind="attr: {id: name }, css: { 'is-selected': $data.selected }">
                                    <button class="btn-icon icon i-drag"><span>drag</span></button>
                                    <button class="btn-zone select" title="select image" type="button" data-bind="event: { click: $parent.onClickImage.bind($data, $parent.mode())}"><span>Select image</span></button>
                                    <div class="ratio-content">
                                        <img data-bind="attr: {src: url + '?w=300&h=300', alt: altText }">
                                    </div>
                                </li>
                            </ul>


                       </div>

                    </div>

                    <div class="form-footer">
                        <p class="form-text block" data-bind="visible: (selectedImages().length < images().length)"><span class="highlight">*</span> Unselected images will not be saved.</p>
                        <button type="button" class="btn icon i-cancel" data-bind="event: { click: onClickCancel }">Cancel</button>
                        <div class="insert-dropdown">
                            <button class="btn-icon insert-dropdown-toggle i-dropdown-simple icon i-ins" data-bind="css:{'is-disable': disable}" type="button"><span>Insert Selected <br>and Save</span></button>
                            <div class="insert-dropdown-list">
                                <button class="btn-icon icon i-ins-ind" data-bind="event: { click: onClickInsert.bind($data, '', 'image') }, css:{'is-disable': disable}" title="Insert Individually" type="button"><span data-bind="text: mode() != 'single-select' ? 'Insert Individually' : 'Save And Insert'">Insert Indivillualy</span></button>
                                <button class="btn-icon icon i-ins-gallery" data-bind="event: { click: onClickInsert.bind($data, '', 'group') }, visible: mode() != 'single-select', css:{'is-disable': disable}" title="Insert as Gallery" type="button"><span>Insert as Gallery</span></button>
                                <button class="btn-icon icon i-ins-grid" data-bind="event: { click: onClickInsert.bind($data, 'grid_view', 'group') }, visible: mode() != 'single-select', css:{'is-disable': disable}" title="Insert as Grid" type="button"><span>Insert as Grid</span></button>
                            </div>
                        </div>
                        <button type="button" class="btn highlight icon i-add-to-gallery" data-bind="event: { click: onClickCreateGroup }, visible: mode() != 'single-select', css:{'is-disable': disable}">Save Selected <br>and Create New Group</button>
                        <button class="btn secondary highlight icon i-save" title="Save All" type="button" data-bind="event: { click: onClickSave }, css:{'is-disable': disable}"><span>Save</span></button>

                    </div>

                </div>
            </div>


            <div id="edit-all-dialog" class="w-img-picker-form">
                <div class="img-picker-form w-form">
                    <div class="form-header">
                        <div class="section-title">
                            <h3 class="section-title">Bulk Edit</h3>
                        </div>
                        <button type="button"  data-bind="event: { click: onClickDismissModal }" class="close-btn icon i-close"></button>
                    </div>

                    <div class="form-body scroll videos_edit">
                        <div class="form-group form-check-inline" data-bind="if: $parent.permissions()['article_edit_embargo'].write">
                            <input type="checkbox" data-bind=" checked: isUnderEmbargo" id="imagePicker-under-embargo_all">
                            <label for="imagePicker-under-embargo_all" class="form-label icon i-check">Under Embargo</label>
                        </div>

                        <div class="form-group form-check-inline">
                            <input type="checkbox" data-bind=" checked: isWaterMark" id="imagePicker-watermark_all">
                            <label for="imagePicker-watermark_all" class="form-label icon i-check">WaterMark</label>
                        </div>

                        <div class="form-group">
                            <label class="form-label" for="">Credit Text</label>
                            <input class="input-text" type="text" id="bulk_image_caption">
                        </div>

                        <div class="form-group">
                            <label class="form-label" for="">description</label>
                            <textarea rows="4" id="bulk_image_description"></textarea>
                        </div>

                        <div class="form-group">
                            <label class="form-label" style="width: auto;">Tags</label>
                            ${this.filterTag.getHtmlBuild()}
                        </div>
                        <div class="form-group" data-bind="foreach: selectedTags, childrenComplete : handleDragAndDrop($element, selectedTags ,'.tag-element')">
                            <div class="btn-selection tag-element">
                                <div class="drag-handle i-move short"><button type="button" class="btn no-bg icon i-drag"></button></div>
                                <input type="radio"
                                    name="imagesTag"
                                    data-bind="
                                        attr: {
                                            value: $data.tag.id,
                                            id: 'imagesTag_' + $data.tag.id,
                                            checked: $parent.idPrimaryTag()? $parent.idPrimaryTag() === $data.tag.id : false
                                        },
                                        event: {
                                            click: $parent.onClickSetSelectedPrimaryTag
                                        }
                                    "
                                >
                                <label class="form-label" data-bind="text: $data.tag.name + ' ' + $data.tag.formattedTagTypeAndDataset, attr: { for: 'imagesTag_' + $data.tag.id }"></label>
                                <button class="icon i-x-after" type="button" data-bind="visible: true, event: { click: $parent.onClickDeleteSelectedTag }"></button>
                            </div>
                        </div>
                    </div>

                    <div class="form-footer">
                        <button type="button" data-bind="click: onClickDismissModal" class="btn">Cancel</button>
                        <button type="button" data-bind="click: onClickOkModal, css:{'is-disable': bulkEditDataIsEmpty  }" class="btn highlight">Apply</button>
                    </div>
                </div>
            </div>
            `;
    }

    private onLoadTemplate () {

        var parent = this;

        var dragSrcEl = null;

        function handleDragStart(e) {
            // Target (this) element is the source node.
            dragSrcEl = this;

            //e.dataTransfer.setData('text', 'foo');
            e.dataTransfer.effectAllowed = 'move';
            e.dataTransfer.setData('text/html', this.outerHTML);

            this.classList.add('dragElem');
        }
        function handleDragOver(e) {
            if (e.preventDefault) {
                e.preventDefault(); // Necessary. Allows us to drop.
            }

            let huit_neuf_this = this;
            //var dragItems = document.querySelectorAll('[draggable=true]');
            var dragItems = document.querySelectorAll('.img-picker-list.bulk-upload .img-picker-item');
            let index = 0;
            let found = false;
            for(let item of dragItems){
                if(dragSrcEl == item){

                    huit_neuf_this.classList.add('after');
                    huit_neuf_this.classList.remove('before');
                    found = true;
                    break;
                }
                if(this == item){

                    huit_neuf_this.classList.add('before');
                    huit_neuf_this.classList.remove('after');
                    found = true;
                    break;
                }
            }

            if(!found){
                this.classList.add("before");
            }
            //this.classList.add("before");

            e.dataTransfer.dropEffect = 'move';  // See the section on the DataTransfer object.

            return false;
        }

        function handleDragEnter(e) {
            // this / e.target is the current hover target.
            //this.classList.add('over');

            //this.classList.add('before');
        }

        function handleDragLeave(e) {
            this.classList.remove('before');
            this.classList.remove('after');  // this / e.target is previous target element.
        }

        function handleDrop(e) {
            // this/e.target is current target element.

            if (e.stopPropagation) {
                e.stopPropagation(); // Stops some browsers from redirecting.
            }

            if (e.preventDefault) {
                e.preventDefault(); // Necessary. Allows us to drop.
            }

            // Don't do anything if dropping the same column we're dragging.
            if (dragSrcEl != this) {


                var dropHTML = e.dataTransfer.getData('text/html');

                if(dropHTML.includes("<li")){
                    for(let child of this.parentNode.childNodes){

                        if(child == dragSrcEl){
                            this.parentNode.removeChild(dragSrcEl);
                        }
                    }


                    if(this.classList.contains("before")){
                        this.insertAdjacentHTML('beforebegin',dropHTML);
                        var dropElem = this.previousElementSibling;
                    }else{
                        this.insertAdjacentHTML('afterend',dropHTML);
                        var dropElem = this.nextElementSibling;
                    }

                    addDnDHandlers(dropElem);
                    //this.reorderImages();
                }



            }
            parent.reorderImages();
            this.classList.remove('before');
            this.classList.remove('after');
            return false;
        }

        function handleDragEnd(e) {
            // this/e.target is the source node.
            this.classList.remove('before');
            this.classList.remove('after');

            [].forEach.call(cols, function (col) {
                col.classList.remove('before');
                col.classList.remove('after');
            });
        }

        function addDnDHandlers(elem) {
            elem.addEventListener('dragstart', handleDragStart, false);
            elem.addEventListener('dragenter', handleDragEnter, false)
            elem.addEventListener('dragover', handleDragOver, false);
            elem.addEventListener('dragleave', handleDragLeave, false);
            elem.addEventListener('drop', handleDrop, false);
            elem.addEventListener('dragend', handleDragEnd, false);

        }

        //var dragItems = document.querySelectorAll('[draggable=true]');
        var cols = document.querySelectorAll('.img-picker-list.bulk-upload .img-picker-item');
        [].forEach.call(cols, addDnDHandlers);


    }


    public setParent(parent){

        this.parent = parent;
        this.filterTag = new filterTag_template("filterTagImagePickerBulkEdit", this.getTemplateViewModel(), this.parent);
    }


    protected initPartial(): void {

        this.filterTag = new filterTag_template("filterTagImagePickerBulkEdit", this.getTemplateViewModel(), this.parent);
        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this.caller);
    }

    protected getTemplateName(): string {
        return "imagePickerBulkEdit-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    protected buildViewModel(): any {

        //create observable array refresh function
        ko.observableArray.fn.refresh = function (item, index) {
            if (index==null) index = this['indexOf'](item);
            if (index >= 0) {
                this.splice(index, 1, ko.utils.extend({}, item)) // create new item
            }
        }

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        let viewModel = {
            isShown: ko.observable(false),
            images: ko.observableArray([]),
            selectedImages: ko.observableArray([]),
            mode: ko.observable("multi-select"),
            actionType: ko.observable("deselect"),
            disable: ko.observable(true),

            isUnderEmbargo : ko.observable(false),
            isWaterMark : ko.observable(false),
            caption : ko.observable(null),
            description : ko.observable(null),
            claidApiErrorMessage : ko.observable(null),
            selectedTags: ko.observable([]),
            idPrimaryTag: ko.observable(null),

            onLoadTemplate: function(data, event){ huit_neuf_this.onLoadTemplate();},
            onClickCancel: function(data, event){ huit_neuf_this.onClickCancel();},
            onClickSave: function(data, event){ huit_neuf_this.onClickSave();},
            onClickImage: function(param, data, event){ huit_neuf_this.onClickImage(param, data);},
            // onSelectImage: function(param, data, event){ huit_neuf_this.onSelectImage(param, data);},
            onClickCreateGroup: function (data, event){ huit_neuf_this.onClickCreateGroup();},
            onSelectAll: function (param, data, event){ huit_neuf_this.onSelectAll(param);},
            onClickInsert: function (param, type, data, event){ huit_neuf_this.onClickInsert(param, type, data);},
            onEditAll: function ( data, event){ huit_neuf_this.onEditAll(data, event);},
            onClickDismissModal: function (){ huit_neuf_this.onClickDismissModal();},
            onClickOkModal: function (){ huit_neuf_this.onClickOkModal();},
            handleDragAndDrop: function (element, currentObservableArray, childrenSelector) {
                huit_neuf_this.handleDragAndDrop(element, currentObservableArray, childrenSelector);
            },
            onClickDeleteSelectedTag: function (data, event) {
                huit_neuf_this.onClickDeleteSelectedTag(data);
            },
            onClickSetSelectedPrimaryTag: function (data, event) {
                huit_neuf_this.setSelectedPrimaryTag(data);
                return true;
            },

        };

        let bulkEditDataIsEmpty = ko.computed(function() {
            return (
                !viewModel.isUnderEmbargo() &&
                !viewModel.isWaterMark() &&
                (viewModel.caption() == null || viewModel.caption() == "") &&
                (viewModel.description() == null || viewModel.description() == "")) &&
                (viewModel.selectedTags() == null || viewModel.selectedTags().length == 0)
        });

        return {...viewModel, bulkEditDataIsEmpty};
    }

    protected onClickCancel(){

        this.getTemplateViewModel().images([])
        this.getTemplateViewModel().selectedImages([]);
        this.hide();
        this.clearEditBulkData()
    }

    public updateSelectedTags() {
        let idTagSelected = this.filterTag.getTemplateViewModel().idTag();
        let tagSelected = this.filterTag.getTemplateViewModel().tagObj();
        let selectedTags = this.getTemplateViewModel().selectedTags();

        if (idTagSelected != null) {
            //add to selected tags if its not already selected
            let alreadySelected = selectedTags.find((t) => t.tag.id == idTagSelected);

            if (!alreadySelected) {
                if (tagSelected.tagType != null) {
                    tagSelected.type = {};
                    tagSelected.type.id = tagSelected.idType;
                    tagSelected.type.name = tagSelected.tagType;
                }
                selectedTags.push({ id: null, tag: tagSelected });
            }
        }

        this.getTemplateViewModel().selectedTags([]);
        this.getTemplateViewModel().selectedTags(selectedTags);
        this.filterTag.clearInput();
    }

    protected setTagFilterAutocomplete(tags) {
        this.filterTag.getTemplateViewModel().tags(tags);
    }

    public handleDragAndDrop(element, currentObservableArray, childrenSelector): any {
        DragAndDropHandler.handleDragAndDrop(element, currentObservableArray, childrenSelector);
    }

    public setSelectedTags(selectedTags): void {
        selectedTags.forEach((t) => {
            let formattedTagTypeAndDataset = "";
            if (t.tag.type != null) {
                formattedTagTypeAndDataset = " (" + t.tag.type.name + ")";
            }

            if (!t.tag["formattedTagTypeAndDataset"]) {
                t.tag["formattedTagTypeAndDataset"] = formattedTagTypeAndDataset;
            }
        });
        this.getTemplateViewModel().selectedTags(selectedTags);
    }

    protected onClickDeleteSelectedTag(data) {
        let idPrimaryTag = this.getTemplateViewModel().idPrimaryTag();
        let selectedTags = this.getTemplateViewModel().selectedTags();
        let index = selectedTags.findIndex((i) => i.tag.id == data.tag.id);
        if (index != -1) {
            selectedTags.splice(index, 1);
        }

        if (idPrimaryTag == data.tag.id) {
            this.getTemplateViewModel().idPrimaryTag(null);
        }

        this.getTemplateViewModel().selectedTags(selectedTags);
    }

    protected setSelectedPrimaryTag(data) {
        this.getTemplateViewModel().idPrimaryTag(data.tag.id);
    }

    public setImages(images){

        for(let image of images){

            if(this.getTemplateViewModel().mode() == 'multi-select' || this.getTemplateViewModel().mode() == 'multi-select-no-gallery'){

                image.selected = true;

            }else{

                image.selected = false;
            }

        }

        let claidApiErrorMessage = sessionStorage.getItem("claidApiErrorMessage");
        if (claidApiErrorMessage) {
            this.setClaidApiErrorMessage(claidApiErrorMessage);
            sessionStorage.removeItem("claidApiErrorMessage");
        }

        if(this.getTemplateViewModel().mode() == 'multi-select' || this.getTemplateViewModel().mode() == 'multi-select-no-gallery'){

            let selectedImages = [...images];
            this.getTemplateViewModel().selectedImages(selectedImages);
        }

        this.getTemplateViewModel().images(images);
        this.toggleButtonClass();
        this.onLoadTemplate();

    }

    public onClickInsert(param, type, data){

        this.saveImages(this.getTemplateViewModel().selectedImages(),true, param, type);
        this.hide();
        this.clearEditBulkData()
    }

    private saveImages(images, insert, param, type){

        images = images.map((image) => {
            image['imageTagIds'] = image.imageTags? image.imageTags.map(({ tag }) => tag.id) : [];
            if (image.imageTags) {
                delete image.imageTags;
            }
            return image;
        });

        this.parent.saveImages(images, insert, param, type);
    }

    public onSelectAll(param){

        let boolean = (param == 'select') ? true : false;

        let images = this.getTemplateViewModel().images();
        for(let image of images){

            image.selected = boolean;
        }

        this.getTemplateViewModel().images([]);
        this.getTemplateViewModel().images(images);

        if(boolean){

            let selectedImages = [...images];
            this.getTemplateViewModel().selectedImages(selectedImages);
            this.getTemplateViewModel().actionType('deselect');
        }else {

            this.getTemplateViewModel().selectedImages([]);
            this.getTemplateViewModel().actionType('select');
        }

        this.toggleButtonClass();
    }

    public onClickCreateGroup(){

        this.saveImages(this.getTemplateViewModel().selectedImages(), false, '', '');
        this.parent.galleryEdit.reset()
        this.parent.galleryEdit.show();
        this.hide();
    }

    public onClickSave(){

        this.saveImages(this.getTemplateViewModel().selectedImages(), false, '', '');
        this.hide();
        this.clearEditBulkData()

    }

    public onClickImage(mode, image){

        if(mode == "single-select"){

            this.selectImage(image);
        }else{

            this.toggleImage(image);
        }

        this.toggleButtonClass()
    }

    protected selectImage(image){

        image.selected = !image.selected;

        let images = this.getTemplateViewModel().images;

        for(let img of images()){

            if(img.name == image.name){

                img.selected = image.selected;
            }else{

                img.selected = false;
            }

            images.refresh(img)
        }

        this.getTemplateViewModel().selectedImages([]);

        if(image.selected) {
            this.getTemplateViewModel().selectedImages([image]);
        }
    }

    protected reorderImages(){
        let images = this.getTemplateViewModel().images();
        let liElements = document.querySelectorAll('.img-picker-list.bulk-upload .img-picker-item');

        //reorder the images based on HTML order
        let newImages = [];
        let newSelectedImages = [];
        for(let element of liElements){

            let image = images.find(i => i.name === element.id);
            if(image){
                newImages.push(image);
                if(image.selected){
                    newSelectedImages.push(image)
                }
            }
        }
        this.getTemplateViewModel().images([]);
        this.getTemplateViewModel().images(newImages);

        this.getTemplateViewModel().selectedImages([]);
        this.getTemplateViewModel().selectedImages(newSelectedImages);
        this.onLoadTemplate();
    }

    protected toggleImage(image){

        image.selected = !image.selected;

        // update the all images to select/deselct
        let images = this.getTemplateViewModel().images;
        let img = images().find(i => i.name === image.name);
        if(img){

            img.selected = image.selected;
            images.refresh(img) // refresh list
        }

        // update the selected list
        this.updateSelectedImages(image);
    }

    protected updateSelectedImages(image){

        let selectedImages = this.getTemplateViewModel().selectedImages;

        if(image.selected){

            let alreadySelected = selectedImages().find(i => i.name === image.name);
            if(!alreadySelected){
                selectedImages().push(image);
            }

        }else{
            let index = selectedImages().findIndex(i => i.name === image.name);
            if(index != -1){
                selectedImages.splice(index,1);
            }
        }

        selectedImages.refresh(image);
    }

    public toggleButtonClass(){

        if(this.getTemplateViewModel().selectedImages().length > 0){

            this.getTemplateViewModel().disable(false);
        }else {
            this.getTemplateViewModel().disable(true);
        }

    }

    public show(){

        this.getTemplateViewModel().isShown(true);
    }

    public hide(){

        this.validationsList.clearMessages();
        this.getTemplateViewModel().isShown(false);
    }

    public setMode(mode){

        this.getTemplateViewModel().mode(mode)
    }

    protected onEditAll(data, event): any {
        this.toggleEditAllModal()

    }

    protected toggleEditAllModal(){
        document.getElementById('edit-all-dialog').classList.toggle('is-visible');
    }

    protected onClickDismissModal(){
        // this.clearEditBulkData()
        this.toggleEditAllModal()
    }

    protected onClickOkModal(){
        this.getTemplateViewModel().description(this.caller.getBulkImageDescription())
        this.getTemplateViewModel().caption(this.caller.getBulkImageCaption())

        //Variables name below must match all image object property
        const isUnderEmbargo = this.getTemplateViewModel().isUnderEmbargo()
        const isWaterMark = this.getTemplateViewModel().isWaterMark()
        const caption = this.getTemplateViewModel().caption()
        const description = this.getTemplateViewModel().description()
        const imageTags = this.getTemplateViewModel().selectedTags();
        const idPrimaryTag = this.getTemplateViewModel().idPrimaryTag();

        let selectedImages = this.getTemplateViewModel().selectedImages()
        let newSelectedImages = []
        for (let selectedImage of selectedImages) {
            selectedImage = {...selectedImage, isUnderEmbargo, isWaterMark, caption, description, imageTags, idPrimaryTag }
            newSelectedImages.push(selectedImage)
        }
        this.getTemplateViewModel().selectedImages(newSelectedImages)
        this.toggleEditAllModal()
    }

    protected clearEditBulkData(){

        sessionStorage.removeItem("claidApiErrorMessage");
        this.caller.clearbulkImageDescriptionEditor()
        this.caller.clearbulkImageCaptionEditor()
        this.getTemplateViewModel()
            .isUnderEmbargo(false)
            .isWaterMark(false)
            .caption(null)
            .description(null)
            .selectedTags([])
            .idPrimaryTag(null);
    }

    public setClaidApiErrorMessage(message){

        this.getTemplateViewModel().claidApiErrorMessage(message);
    }
}



// WEBPACK FOOTER //
// ./vendor/valnet/valnet_imagePicker/js/components/templates/imagePickerBulkEdit_template.ts